const reloadGuardKey = 'z-web_dynamic-import-reload'

const isDynamicImportFailure = (error) =>
  /Failed to fetch dynamically imported module|Unable to preload CSS/i.test(error?.message || '')

const showStaticFallback = () => {
  document.body.innerHTML = '<main style="font-family:system-ui,sans-serif;display:grid;min-height:100vh;place-items:center;margin:0;background:#f5f5f5;color:#1f2937"><section style="max-width:32rem;padding:2rem;text-align:center;background:white;border-radius:.75rem;box-shadow:0 8px 24px rgba(0,0,0,.08)"><h1 style="margin-top:0">页面资源加载失败</h1><p>请检查网络连接或稍后重试。</p><button type="button" onclick="window.location.reload()">重新加载</button></section></main>'
}

export const recoverDynamicImportFailure = (error) => {
  if (!isDynamicImportFailure(error)) return false
  if (!sessionStorage.getItem(reloadGuardKey)) {
    sessionStorage.setItem(reloadGuardKey, '1')
    window.location.reload()
  } else {
    sessionStorage.removeItem(reloadGuardKey)
    showStaticFallback()
  }
  return true
}
